const AXIS_IDS = new Set(['axis', 'xaxis', 'yaxis', 'x axis', 'y axis'])

function isAxisGroup(el) {
  const id = (el.getAttribute('id') || '').toLowerCase().trim()
  return AXIS_IDS.has(id)
}

/**
 * Some RAWGraphs charts (e.g. line chart) place axis groups inside the same
 * clip-path container that restrains the series data.  Rotated or long tick
 * labels that extend into the margin area are silently clipped there.
 *
 * Fix: for any clipped container that holds an axis sibling, move the
 * clip-path attribute directly onto the non-axis <g> children so the data
 * stays clipped while axis labels can extend freely.
 */
export function releaseAxisFromClipPath(svgNode) {
  if (!svgNode) return

  const clippedContainers = Array.from(svgNode.querySelectorAll('[clip-path]'))

  for (const container of clippedContainers) {
    const children = Array.from(container.children)
    const axisChildren = children.filter(isAxisGroup)

    // Only act when an axis group shares the clip with data children
    if (!axisChildren.length) continue

    const dataChildren = children.filter(
      (c) => !isAxisGroup(c) && c.tagName.toLowerCase() === 'g'
    )
    if (!dataChildren.length) continue

    const clipValue = container.getAttribute('clip-path')
    container.removeAttribute('clip-path')

    for (const child of dataChildren) {
      child.setAttribute('clip-path', clipValue)
    }
  }
}
